export enum CommentTypes {
  VACAY = 1,
  ROSTR = 2
}
